import {FC} from "react";
import {Card} from "react-bootstrap";
import Loader from "@/components/common/loader/loader";
import useEngagementTeam from "@oldDashboard/legacyHooks/useEngagementTeam";
import { TimePeriods } from "@oldDashboard/legacyModels/timePeriods.model";
import { EngagementTeam } from "@oldDashboard/legacyModels/engagementTeam.model";

interface EngagementsTeamProps { engagementTeam: EngagementTeam, timePeriods: TimePeriods[], affiliateSelected: String,launchSelected: String, timePeriodSelected: string,  searching: boolean }
const EngagementsTeamTile: FC<EngagementsTeamProps> = (props) => {
    const { engagementTeam, timePeriods, affiliateSelected, launchSelected, timePeriodSelected, searching } = props;
    const { isLoading } = useEngagementTeam({affiliateSelected, launchSelected, timePeriods, timePeriodSelected, searching});
    return (
        <Card className="custom-card overflow-hidden position-relative" style={{height: '250px'}}>
            { isLoading && <Loader/> }
            <Card.Header className="justify-content-between">
                <Card.Title>
                    Your Dedicated Engagement Team
                </Card.Title>
            </Card.Header>
            <Card.Body className="pt-3">
                <div className="row gap-3 gap-sm-0 d-flex align-items-center">
                    <div className="row">
                        { engagementTeam.engagementManager != "" && engagementTeam.engagementManagerEmail != "" &&
                            <div className="col-12 text-center">
                                <h5 className="fw-semibold mb-2 pt-0 fs-18">Launch POC</h5>
                                <h6 className="fs-13">{engagementTeam.engagementManager}</h6>
                                <h6 className="fs-13">{engagementTeam.engagementManagerEmail}</h6>
                            </div>
                        }
                        { engagementTeam.enterprisePartnershipManager != "-" && engagementTeam.enterprisePartnershipManagerEmail != "-" &&
                        <div className="col-12 text-center">
                            <h5 className="fw-semibold mb-2 pt-3 fs-18"> Partnership POC</h5>
                            {
                                engagementTeam.enterprisePartnershipManager != "-" &&
                                <h6 className="fs-13">{engagementTeam.enterprisePartnershipManager}</h6>
                            }
                            {
                                engagementTeam.enterprisePartnershipManagerEmail != "-" &&
                                <h6 className="fs-13">{engagementTeam.enterprisePartnershipManagerEmail}</h6>
                            }
                        </div>
                    }
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default EngagementsTeamTile;
